export const isCourierConsumer = (name = '') => /courier/i.test(name);
